import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  Paper,
  TableBody,
  IconButton,
} from "@mui/material";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import Subheader from "../../../Componants/Common/Subheader";
import CommonButton from "../../../Componants/Common/Button";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";

import { Constants } from "../../../constants/Constants";
import toast, { Toaster } from "react-hot-toast";
import {
  createPackage,
  fetchModule,
  fetchPackageList,
  fetchParentModule,
  updatePackage,
  updatePackageStatus,
} from "../../../API Service/apiService";
import Loader from "../../../Componants/Loader/Loader";
import { useFormik } from "formik";
import * as Yup from "yup";
import DynamicTabs from "../../../components/DynamicTabs";
import { formatDate } from "../../../utils/dateFormatter";

const modules = [
  { _id: "67a6e75b2e438ac4ebee0393", moduleName: "call-dashboar" },
  { _id: "67ac4167c53fefc0e8dc1147", moduleName: "test" },
  { _id: "67ac41fda579e0506b6dae8a", moduleName: "dashboard" },
  { _id: "67ac4216a579e0506b6dae8b", moduleName: "setting" },
  { _id: "67ac802dd10555a30356a970", moduleName: "admin dashboard" },
];

const cells = [
  "Name",
  "Description",
  "Per User License",
  "Modules",
  "Created On",
  "Created By",
  "Status",
  "Action",
];

/*

 packageName: "premium",
    description: "include 4 module",
    perUserPrice: 9,
    modules: [
      { id: "67a6e75b2e438ac4ebee0393" },
      { id: "67a6f9fb658d2a48bfd35e83" },
      { id: "67a6fa80658d2a48bfd35e85" },
      { id: "67a6fa4b658d2a48bfd35e84" },
    ],

*/

// Define validation schema using Yup
const validationSchema = Yup.object({
  packageName: Yup.string()
    .required("Name is required")
    .max(50, "Name must be 50 characters or less")
    .matches(/^[A-Za-z ]+$/, "Name can only contain alphabet."),
  description: Yup.string()
    .required("Description is required")
    .max(100, "Description must be 100 characters or less"),
  perUserPrice: Yup.number()
    .required("Per User License Cost is required")
    .typeError("Per User License Cost must be a number"),
  modules: Yup.array().min(1, "At least one module must be selected"),
});

const CreateSubscription = () => {
  const [status, setStatus] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [moduleList, setModuleList] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const topRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      packageName: "",
      description: "",
      perUserPrice: "",
      modules: [],
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const params = {
          packageName: values.packageName,
          description: values.description,
          perUserPrice: values.perUserPrice,
          modules: values.modules
            .filter((moduleId) => moduleId)
            .map((moduleId) => (  moduleId )),
        };
        const response = await createPackage(params);
        if (response) {
          toast.success(response.message);
          getPackageList();
          formik.resetForm();
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.log(`Error in creating package`, error);
        toast.error(error.response.data.message);
      } finally {
        setLoading(false);
      }
    },
  });

  const getPackageList = async () => {
    try {
      setLoading(true);
      const response = await fetchPackageList();
      if (response.success === true) {
        // Ensure data is properly formatted before setting state
        const formattedPackages = response.packages.map((pkg) => ({
          ...pkg,
          // Convert any potential object values to strings

          license:
            typeof pkg.license === "object"
              ? JSON.stringify(pkg.license)
              : pkg.license?.toString() || "N/A",
        }));
        setTableData(formattedPackages);
        setTotalRecords(response.totalPackages);
      } else {
        setTableData([]);
        toast.error(response.message);
      }
    } catch (error) {
      console.log(`Error in fetching package list`, error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getModuleDropdown = async () => {
    try {
      setLoading(true);
      const response = await fetchModule();

      if (response.status == "success") {
        console.log(response.data);
        setModuleList(response.data);
      }
    } catch (error) {
      console.error("Error fetching module dropdown:", error);
      toast.error("Error fetching module dropdown");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPackageList();
    getModuleDropdown();
  }, []);

  // Helper function to safely render cell content
  const renderCellContent = (content) => {
    if (content === null || content === undefined) return "N/A";
    if (typeof content === "object") return JSON.stringify(content);
    return content.toString();
  };

  // Define the handleUpdate function
  const handleUpdate = async (packageId) => {
    try {
      setLoading(true);
      // Log form values for debugging
      console.log("Updating package with values:", formik.values);

      // Validate form values
      if (
        !formik.values.packageName ||
        !formik.values.description ||
        !formik.values.perUserPrice ||
        formik.values.modules.length === 0
      ) {
        toast.error("Please fill out all required fields.");
        return;
      }

      const params = { packageId: packageId };
      const data = {
        packageName: formik.values.packageName,
        description: formik.values.description,
        perUserPrice: formik.values.perUserPrice,
        modules: formik.values.modules
          .filter((moduleId) => moduleId)
          .map((moduleId) => ({ id: moduleId })),
      };

      const response = await updatePackage(params, data);
      if (response.success) {
        toast.success(response.message);
        formik.resetForm();
        getPackageList(); // Refresh the package list
        setIsEditMode(false); // Reset edit mode
        setSelectedPackageId(null); // Reset selected package ID
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error updating package:", error);
      toast.error("Failed to update package");
    } finally {
      setLoading(false);
    }
  };

  // Function to handle edit icon click
  const handleEditClick = (packageData) => {
    console.log(packageData);
    topRef.current?.scrollIntoView({ behavior: "smooth" });
    setIsEditMode(true);
    setSelectedPackageId(packageData._id);
    formik.setValues({
      packageName: packageData.packageName,
      description: packageData.description,
      perUserPrice: packageData.perUserPrice,
      modules: packageData.modules.map((module) => module.id),
    });
  };

  // Modify form submission logic based on mode
  const handleSubmit = async (values) => {
    if (isEditMode) {
      await handleUpdate(selectedPackageId);
      setIsEditMode(false);
      setSelectedPackageId(null);
    } else {
      await formik.handleSubmit(values);
    }
  };

  const handleStatusUpdate = async (packageId) => {
    try {
      setLoading(true);
      const params = { packageId: packageId };

      const response = await updatePackageStatus(params);
      if (response.success) {
        toast.success(response.message);
        getPackageList(); // Refresh the package list
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error updating package status:", error);
      toast.error("Failed to update package status");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} ref={topRef}>
      <Toaster />
      {loading && <Loader />}
      <HeaderNavigation value={Constants.package} />
      <DynamicTabs />
      <Grid container>
        <Grid
          sx={{
            background: "#EFF3FE",
            marginLeft: "10px",
            marginTop: "4px",
            marginRight: "10px",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
            width: "100%",
            borderRadius: "5px",
            padding: "10px",
            fontWeight: 600,
          }}
        >
          <Subheader heading={Constants.createPackage} />
          <Grid container gap={6}>
            <Grid item xs={8} md={3}>
              <TextField
                fullWidth
                id="packageName"
                name="packageName"
                label="Name"
                variant="standard"
                value={formik.values.packageName}
                onChange={formik.handleChange}
                error={
                  formik.touched.packageName &&
                  Boolean(formik.errors.packageName)
                }
                helperText={
                  formik.touched.packageName && formik.errors.packageName
                }
                sx={{ maxWidth: "200px" }}
              />
            </Grid>
            <Grid item xs={8} md={3}>
              <TextField
                fullWidth
                id="description"
                name="description"
                label="Description"
                variant="standard"
                value={formik.values.description}
                onChange={formik.handleChange}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
                sx={{ maxWidth: "200px" }}
              />
            </Grid>
            <Grid item xs={8} md={3}>
              <TextField
                fullWidth
                id="perUserPrice"
                name="perUserPrice"
                label="Per User License Cost"
                variant="standard"
                value={formik.values.perUserPrice}
                onChange={formik.handleChange}
                error={
                  formik.touched.perUserPrice &&
                  Boolean(formik.errors.perUserPrice)
                }
                helperText={
                  formik.touched.perUserPrice && formik.errors.perUserPrice
                }
                sx={{ maxWidth: "200px" }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={3}>
            <Grid item xs={12}>
              <Subheader heading="Select Modules" />
            </Grid>
            {moduleList.map((module) => (
              <Grid item xs={12} sm={6} md={3} key={module._id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="modules"
                      value={module._id}
                      checked={formik.values.modules.includes(module._id)}
                      onChange={formik.handleChange}
                    />
                  }
                  label={module.moduleName}
                />
              </Grid>
            ))}

            {formik.touched.modules && formik.errors.modules && (
              <div style={{ color: "red", marginLeft: "10px" }}>
                {formik.errors.modules}
              </div>
            )}
          </Grid>
          <Grid
            container
            gap={3}
            justifyContent="flex-end"
            sx={{
              background: "#EFF3FE",
              marginLeft: "10px",
              marginTop: "4px",
              marginRight: "10px",
              fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
              width: "100%",
              borderRadius: "5px",
              padding: "10px",
              fontWeight: 600,
            }}
          >
            <CommonButton
              name={isEditMode ? "Update" : Constants.create}
              handleOnClick={handleSubmit}
            />
            <CommonButton
              name={Constants.cancel}
              handleOnClick={formik.resetForm}
            />
          </Grid>
        </Grid>
        <Grid
          sx={{
            background: "#EFF3FE",
            marginLeft: "10px",
            marginTop: "4px",
            marginRight: "10px",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
            width: "100%",
            borderRadius: "5px",
            padding: "10px",
            paddingBottom: "35px",
            fontWeight: 600,
          }}
        >
          <Grid container>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650, width: '100%' }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {cells.map((cell, index) => (
                      <TableCell
                        key={index}
                        sx={{ color: "white", textAlign: "center" }}
                      >
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.length > 0 ? (
                    tableData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          {renderCellContent(row.packageName)}
                        </TableCell>
                        <TableCell align="center">
                          {renderCellContent(row.description)}
                        </TableCell>
                        <TableCell align="center">
                          {renderCellContent(row.perUserPrice)}
                        </TableCell>
                        <TableCell align="center">
                          {renderCellContent(row.numberOfModule)}
                        </TableCell>
                        <TableCell align="center">
                          {formatDate(row.createdOn)}
                        </TableCell>
                        <TableCell align="center">
                          {renderCellContent(row.createdBy || "NA")}
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            sx={{
                              outline: "none",
                              "&:focus": { outline: "none" },
                            }}
                            onClick={() => handleStatusUpdate(row._id)}
                          >
                            <img
                              src={row.status ? activeIcon : inactiveIcon}
                              alt={row.status ? "active" : "inactive"}
                              height="20px"
                              width="20px"
                            />
                          </IconButton>
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            sx={{
                              outline: "none",
                              "&:focus": { outline: "none" },
                            }}
                            onClick={() => handleEditClick(row)}
                          >
                            <img
                              src={editIcon}
                              alt="edit"
                              height="20px"
                              width="20px"
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No data found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default CreateSubscription;
